<template>
  <UCard :ui="{ body: 'p-4' }" class="hover:ring-2 hover:ring-primary-500 transition-shadow">
    <div class="flex flex-col gap-2">
      <div class="flex items-start justify-between gap-2">
        <span class="text-sm font-medium text-gray-900 dark:text-white line-clamp-2">
          {{ epic.title }}
        </span>
      </div>
      <div v-if="priorityLabel" class="flex flex-wrap gap-1">
        <UBadge :color="priorityLabel.color" size="xs" variant="soft">
          {{ priorityLabel.text }}
        </UBadge>
      </div>
    </div>
  </UCard>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

interface GitlabEpic {
  id: number
  iid: number
  title: string
  description: string
  web_url: string
  labels: string[]
}

const props = defineProps<{
  epic: GitlabEpic
}>()

const priorityLabel = computed(() => {
  const labels = (props.epic.labels || []).map((l) => l.toLowerCase())
  if (labels.includes('priority::high')) return { text: 'Prio: hoch', color: 'error' }
  if (labels.includes('priority::normal')) return { text: 'Prio: mittel', color: 'warning' }
  // Even if priority::low is not explicitly present, we default to it for sorting, so we show it here as well.
  return { text: 'Prio: gering', color: 'primary' }
})
</script>
